import { Component, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { ModulesSelectors } from '@serviceos-ng/core';
import { Observable } from 'rxjs';
import { AvatarForm } from '../avatar-form/avatar-form.component';
import { BirthdayForm } from '../birthdate-form/birthdate-form.component';
import { NamesForm } from '../name-form/name-form.component';
import { PasswordFormConfig } from '../password-form/password-form.component';

export interface AccountDetailsCard {
  title: string;
  description: string;
  avatar: AvatarForm;
  birthday: BirthdayForm;
  names: NamesForm;
  password: PasswordFormConfig;
}

@Component({
  selector: 'serviceos-web-account-details-card',
  templateUrl: './account-details-card.component.html',
  styleUrls: ['./account-details-card.component.scss']
})
export class AccountDetailsCardComponent implements OnInit {

  @Select(ModulesSelectors.getComponentFromModule('account', 'account_settings_screen.account_details'))
  accountSettingsConfig$!: Observable<AccountDetailsCard | null>

  @Select(ModulesSelectors.getSetting('disable_birthday'))
  birthday_disable$!: Observable<boolean>;

  constructor() { }

  ngOnInit(): void {
  }

}
